import { render, staticRenderFns } from "./BankRemitsPage.vue?vue&type=template&id=31604307&scoped=true&"
import script from "./BankRemitsPage.vue?vue&type=script&lang=ts&"
export * from "./BankRemitsPage.vue?vue&type=script&lang=ts&"
import style0 from "./BankRemitsPage.vue?vue&type=style&index=0&id=31604307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31604307",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VTooltip})
